import React from 'react'
import { Helmet } from 'react-helmet-async'
import Hero from '../components/home/Hero'
import Services from '../components/home/Services'
import WhyChooseUs from '../components/home/WhyChooseUs'
import Pricing from '../components/home/Pricing'
import Testimonials from '../components/home/Testimonials'
import FAQ from '../components/home/FAQ'
import CTABanner from '../components/home/CTABanner'

export default function Home() {
  return (
    <>
      <Helmet>
        <title>A Plus A Driving School - Professional Driver Education in Virginia</title>
        <meta name="description" content="Virginia's premier driving school offering comprehensive driver education for teens and adults. DMV licensed, professional instructors, flexible schedules, and proven success rates." />
        <meta name="keywords" content="driving school, driver education, Virginia, Stafford, DMV licensed, teen drivers, adult driving lessons" />
      </Helmet>
      <Hero />
      <Services />
      <WhyChooseUs />
      <Pricing />
      <Testimonials />
      <FAQ />
      <CTABanner />
    </>
  )
}

